// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.businessEstablishmentSettings {
  background-color: #f3f4f6;
}
.businessEstablishmentSettings .heading {
  position: relative;
  display: block;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 41px;
  color: #353d47;
  margin: 20px auto;
  width: 80%;
}
.businessEstablishmentSettings .heading .headingImage {
  display: inline-block;
}
.businessEstablishmentSettings .heading .headingText {
  position: relative;
  bottom: 15px;
  left: 10px;
  display: inline-block;
}
.businessEstablishmentSettings .container {
  background: #ffffff;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  width: 80%;
  margin: auto;
  margin-bottom: 42px;
  cursor: normal;
  display: block;
  padding-left: 30px;
  font-size: 22px;
}
.businessEstablishmentSettings .firstSectionWrapper {
  display: flex;
  justify-content: space-between;
}
.businessEstablishmentSettings .firstSectionWrapper .headingOne {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  margin-bottom: 9px;
  margin-top: 62px;
}
.businessEstablishmentSettings .leftContainer {
  width: 70%;
  margin-right: 1px;
  padding: 28px 13% 0 0;
  margin-bottom: 60px;
}
.businessEstablishmentSettings .rightContainer {
  width: calc(32% - 16px);
  padding: 28px;
  padding-top: 86px;
  border-left: 1px solid #f2f2f2;
}
.businessEstablishmentSettings .rightContainer .headingText {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  margin-bottom: 9px;
}
.businessEstablishmentSettings .rightContainer .contextText {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}
.businessEstablishmentSettings .rightContainer .contextOne {
  margin-bottom: 38px;
}
.businessEstablishmentSettings .rightContainer .contextTwo {
  margin-bottom: 121px;
}
.businessEstablishmentSettings .rightContainer .contextThree {
  margin-bottom: 66px;
}
.businessEstablishmentSettings .boxHeader {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 32px;
}
.businessEstablishmentSettings .secondSectionWrapper {
  margin: auto;
  display: flex;
  margin-top: 13px;
  justify-content: space-between;
}
.businessEstablishmentSettings .secondSectionWrapper .leftContainer {
  width: 70%;
  margin-right: 1px;
  padding: 28px 13% 0 0;
  margin-bottom: 60px;
}
.businessEstablishmentSettings .secondSectionWrapper .rightContainer {
  width: calc(32% - 16px);
  padding: 28px;
}
.businessEstablishmentSettings .secondSectionWrapper .rightContainer .headingText {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  margin-bottom: 9px;
}
.businessEstablishmentSettings .secondSectionWrapper .rightContainer .contextText {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}
.businessEstablishmentSettings .secondSectionWrapper .rightContainer .headingOne {
  margin-top: 61px;
}
.businessEstablishmentSettings .secondSectionWrapper .rightContainer .headingTwo {
  margin-bottom: 0px;
}
.businessEstablishmentSettings .secondSectionWrapper .rightContainer .contextOne {
  margin-top: -7px;
}
.businessEstablishmentSettings .secondSectionWrapper .rightContainer .contextTwo {
  margin-bottom: 43px;
}
.businessEstablishmentSettings .secondSectionWrapper .rightContainer .contextThree {
  margin-bottom: 15px;
}
.businessEstablishmentSettings .thirdSectionWrapper {
  margin: auto;
  display: flex;
  margin-top: 13px;
  justify-content: space-between;
}
.businessEstablishmentSettings .thirdSectionWrapper .rightContainer {
  width: calc(32% - 16px);
  padding: 28px;
}
.businessEstablishmentSettings .thirdSectionWrapper .rightContainer .headingText {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  margin-bottom: 9px;
}
.businessEstablishmentSettings .thirdSectionWrapper .rightContainer .contextText {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}
.businessEstablishmentSettings .thirdSectionWrapper .rightContainer .headingOne {
  margin-top: 56px;
}
.businessEstablishmentSettings .thirdSectionWrapper .rightContainer .contextOne {
  margin-top: 18px;
}
.businessEstablishmentSettings .thirdSectionWrapper .rightContainer .contextTwo {
  margin-bottom: 121px;
}
.businessEstablishmentSettings .thirdSectionWrapper .rightContainer .contextThree {
  margin-bottom: 66px;
}
.businessEstablishmentSettings .finalWrapper {
  padding-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/screens/businessEstablishmentSettings/businessEstablishmentSettings.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;AACI;EACI,kBAAA;EACA,cAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AACR;AAAQ;EACI,qBAAA;AAEZ;AAAQ;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;AAEZ;AAEI;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAAR;AAEI;EACI,aAAA;EACA,8BAAA;AAAR;AACQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AACZ;AAGI;EACI,UAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;AADR;AAII;EACI,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,8BAAA;AAFR;AAGQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AADZ;AAIQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,cAAA;AAHZ;AAMQ;EACI,mBAAA;AAJZ;AAMQ;EACI,oBAAA;AAJZ;AAMQ;EACI,mBAAA;AAJZ;AAQI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AANR;AASI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;AAPR;AASQ;EACI,UAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;AAPZ;AASQ;EACI,uBAAA;EACA,aAAA;AAPZ;AASY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAPhB;AAUY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARhB;AAWY;EACI,gBAAA;AAThB;AAWY;EACI,kBAAA;AAThB;AAWY;EACI,gBAAA;AAThB;AAWY;EACI,mBAAA;AAThB;AAWY;EACI,mBAAA;AAThB;AAcI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;AAZR;AAcQ;EACI,uBAAA;EACA,aAAA;AAZZ;AAcY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAZhB;AAeY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAbhB;AAgBY;EACI,gBAAA;AAdhB;AAiBY;EACI,gBAAA;AAfhB;AAiBY;EACI,oBAAA;AAfhB;AAiBY;EACI,mBAAA;AAfhB;AAmBI;EACI,oBAAA;AAjBR","sourcesContent":[".businessEstablishmentSettings {\n    background-color: #f3f4f6;\n\n    .heading {\n        position: relative;\n        display: block;\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 28px;\n        line-height: 41px;\n        color: #353d47;\n        margin: 20px auto;\n        width: 80%;\n        .headingImage {\n            display: inline-block;\n        }\n        .headingText {\n            position: relative;\n            bottom: 15px;\n            left: 10px;\n            display: inline-block;\n        }\n    }\n\n    .container {\n        background: #ffffff;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px;\n        width: 80%;\n        margin: auto;\n        margin-bottom: 42px;\n        cursor: normal;\n        display: block;\n        padding-left: 30px;\n        font-size: 22px;\n    }\n    .firstSectionWrapper {\n        display: flex;\n        justify-content: space-between;\n        .headingOne {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            color: #505054;\n            margin-bottom: 9px;\n            margin-top: 62px;\n        }\n    }\n\n    .leftContainer {\n        width: 70%;\n        margin-right: 1px;\n        padding: 28px 13% 0 0;\n        margin-bottom: 60px;\n    }\n\n    .rightContainer {\n        width: calc(32% - 16px);\n        padding: 28px;\n        padding-top: 86px;\n        border-left: 1px solid #f2f2f2;\n        .headingText {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            color: #505054;\n            margin-bottom: 9px;\n        }\n\n        .contextText {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n\n            color: #999999;\n        }\n\n        .contextOne {\n            margin-bottom: 38px;\n        }\n        .contextTwo {\n            margin-bottom: 121px;\n        }\n        .contextThree {\n            margin-bottom: 66px;\n        }\n    }\n\n    .boxHeader {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        margin-bottom: 32px;\n    }\n\n    .secondSectionWrapper {\n        margin: auto;\n        display: flex;\n        margin-top: 13px;\n        justify-content: space-between;\n\n        .leftContainer {\n            width: 70%;\n            margin-right: 1px;\n            padding: 28px 13% 0 0;\n            margin-bottom: 60px;\n        }\n        .rightContainer {\n            width: calc(32% - 16px);\n            padding: 28px;\n\n            .headingText {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n                margin-bottom: 9px;\n            }\n\n            .contextText {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 18px;\n                color: #999999;\n            }\n\n            .headingOne {\n                margin-top: 61px;\n            }\n            .headingTwo {\n                margin-bottom: 0px;\n            }\n            .contextOne {\n                margin-top: -7px;\n            }\n            .contextTwo {\n                margin-bottom: 43px;\n            }\n            .contextThree {\n                margin-bottom: 15px;\n            }\n        }\n    }\n\n    .thirdSectionWrapper {\n        margin: auto;\n        display: flex;\n        margin-top: 13px;\n        justify-content: space-between;\n\n        .rightContainer {\n            width: calc(32% - 16px);\n            padding: 28px;\n\n            .headingText {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                line-height: 20px;\n                color: #505054;\n                margin-bottom: 9px;\n            }\n\n            .contextText {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 18px;\n                color: #999999;\n            }\n\n            .headingOne {\n                margin-top: 56px;\n            }\n\n            .contextOne {\n                margin-top: 18px;\n            }\n            .contextTwo {\n                margin-bottom: 121px;\n            }\n            .contextThree {\n                margin-bottom: 66px;\n            }\n        }\n    }\n    .finalWrapper {\n        padding-bottom: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
